/**
 * Wishlist Drawer Auto-Open on Add — PLP/PDP 위시리스트 버튼(♡) 클릭 후 좌측 위시리스트 드로어 자동 open.
 *
 * 트리거: `.swym-advanced-wishlist-collections` (PLP card + PDP 공통 Swym 컴포넌트)
 *
 * 동작:
 *   1. 클릭 가로채기 (capture: false — Swym 의 자체 핸들러 먼저 동작 후 우리 핸들러)
 *   2. aria-pressed=true 면 remove 동작 → drawer 안 엶
 *   3. add 동작 → Swym 의 async add 처리 완료까지 setTimeout(350) 대기 → drawer.open()
 *
 * API (2026-05-21 dev preview 확인):
 *   - <swym-storefront-layout-as-drawer> Custom Element 의 open() / close() 메서드 노출
 *   - SwymGhostWishlistDrawer.open() — 비로그인 + consent 미동의 케이스 fallback
 *
 * Swym 어드민 설정 (참고):
 *   - storefrontLayoutType: 'as-drawer'
 *   - storefrontLayoutDrawerWidth: 400
 *   - launchType: 'floating'
 *
 * 회귀 함정:
 *   - Swym 의 add 가 async (XHR + render). 즉시 drawer.open() 호출하면 빈 drawer 노출 가능
 *     → setTimeout 으로 race 회피
 *   - aria-pressed 검사로 remove 시 drawer 안 열기. 단 Swym 이 클릭 즉시 aria-pressed 토글하므로
 *     클릭 직전(capture=false 시점) 값 = 직전 상태 = remove 여부 판단 가능
 */

(function () {
  'use strict';

  // PLP: .swym-advanced-wishlist-collections (PLP 카드 하트)
  // PDP: .swym-btn-position-product-title (PDP 상품명 옆 하트 wrapper — 내부 button 까지 포함)
  const WISHLIST_BTN_SELECTOR = '.swym-advanced-wishlist-collections, .swym-btn-position-product-title, .swym-btn-position-product-title button';
  const DRAWER_OPEN_DELAY_MS = 350;

  function openWishlistDrawer() {
    // 🔴 1순위: floating launcher button 직접 click — 사용자 클릭과 동일 코드 경로 (data fetch + DOM mount + transition lifecycle 전체 트리거)
    //    drawer.open() API 만으론 visible 0x0 회귀 (state 만 바뀌고 lifecycle 미트리거) → anchor.click() 으로 우회
    // 🔴 #swym-anchor 는 wrapper div (clickable X). 실제 click 타겟은 그 안의 <a id="notepad-anchor-title" href="#swym-wishlist">
    const anchor = document.querySelector('#notepad-anchor-title, #swym-anchor a, #swym-plugin button, #swym-hosted-plugin button');
    if (anchor) {
      try {
        anchor.click();
        return;
      } catch (e) {
        console.warn('[wishlist-open-on-add] anchor.click() failed:', e);
      }
    }

    // 2순위: Swym storefront-layout-as-drawer custom element 의 open()
    const drawer = document.querySelector('swym-storefront-layout-as-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (e) {
        console.warn('[wishlist-open-on-add] drawer.open() failed:', e);
      }
    }

    // 3순위: Ghost (비로그인 + consent 미동의) 케이스
    if (window.SwymGhostWishlistDrawer && typeof window.SwymGhostWishlistDrawer.open === 'function') {
      try {
        window.SwymGhostWishlistDrawer.open();
        return;
      } catch (e) {
        console.warn('[wishlist-open-on-add] ghost drawer open failed:', e);
      }
    }
  }

  function init() {
    // 🔴 capture: true — Swym 자체 핸들러가 stopPropagation 으로 bubble 단계 차단할 수 있어 capture 단계에서 미리 가로채기
    document.addEventListener('click', function (e) {
      const btn = e.target.closest(WISHLIST_BTN_SELECTOR);
      if (!btn) return;

      // remove 동작 — drawer 안 엶
      if (btn.getAttribute('aria-pressed') === 'true') return;

      // Swym async add 처리 완료 후 drawer 열기 (race 회피)
      setTimeout(openWishlistDrawer, DRAWER_OPEN_DELAY_MS);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
